var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToasterInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6085_24166)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 27,
    r: 18,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0003 18.6665C25.4087 18.6665 21.667 22.4082 21.667 26.9998C21.667 31.5915 25.4087 35.3332 30.0003 35.3332C34.592 35.3332 38.3337 31.5915 38.3337 26.9998C38.3337 22.4082 34.592 18.6665 30.0003 18.6665ZM29.3753 23.6665C29.3753 23.3248 29.6587 23.0415 30.0003 23.0415C30.342 23.0415 30.6253 23.3248 30.6253 23.6665V27.8332C30.6253 28.1748 30.342 28.4582 30.0003 28.4582C29.6587 28.4582 29.3753 28.1748 29.3753 27.8332V23.6665ZM30.767 30.6498C30.7253 30.7582 30.667 30.8415 30.592 30.9248C30.5087 30.9998 30.417 31.0582 30.317 31.0998C30.217 31.1415 30.1087 31.1665 30.0003 31.1665C29.892 31.1665 29.7837 31.1415 29.6837 31.0998C29.5837 31.0582 29.492 30.9998 29.4087 30.9248C29.3337 30.8415 29.2753 30.7582 29.2337 30.6498C29.192 30.5498 29.167 30.4415 29.167 30.3332C29.167 30.2248 29.192 30.1165 29.2337 30.0165C29.2753 29.9165 29.3337 29.8248 29.4087 29.7415C29.492 29.6665 29.5837 29.6082 29.6837 29.5665C29.8837 29.4832 30.117 29.4832 30.317 29.5665C30.417 29.6082 30.5087 29.6665 30.592 29.7415C30.667 29.8248 30.7253 29.9165 30.767 30.0165C30.8087 30.1165 30.8337 30.2248 30.8337 30.3332C30.8337 30.4415 30.8087 30.5498 30.767 30.6498Z",
    fill: "#FF9500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6085_24166",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6085_24166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6085_24166",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterInfo);
export default __webpack_public_path__ + "static/media/toasterInfo.788c27817b22d6a53ec37eec404ce265.svg";
export { ForwardRef as ReactComponent };